import { Box, Typography } from '@mui/material';
import React from 'react';
import classNames from 'classnames';
import { ModuleConfig } from '@schamburg-web/interfaces';
import { useModules } from '@schamburg-web/components';

const MapLayerChooserButton: React.FC<{ module: ModuleConfig }> = ({
  module,
}) => {
  const { modulesEnabled } = useModules();
  const isModuleEnabled = modulesEnabled[module.name];
  return (
    <Box
      className={classNames('map-layer-button', {
        off: !isModuleEnabled,
      })}
      sx={{ display: 'flex' }}
    >
      {module.mapConfig.layerIcon && (
        <img
          src={`${module.mapConfig.layerIcon}`}
          alt={''}
          className="map-layer-image"
        />
      )}
      <Typography
        sx={{
          fontFamily: 'verdana',
          width: '100%',
          textAlign: 'left',
        }}
        variant="body2"
      >
        {module.moduleLabel}
      </Typography>
    </Box>
  );
};

export default MapLayerChooserButton;
